import { DELETE, GET, PATCH, POST, PUT } from "../axios/apiService";

const getEnrichBaseUrl = (slug) => {
  if (["whatfix-staging", "whatfix"].includes(slug)) {
    return `${process.env.REACT_APP_API_BASE_URL}/api/v1`;
  }
  return `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/v2`;
};

export const getEnrichmentList = async ({ query, slug, options }) => {
  const baseUrl = getEnrichBaseUrl(slug);
  const url = `${baseUrl}/enrich${query ? `?${query}` : ""}`;
  return GET(url, options);
};

export const enrichCSVMapColumns = async ({ data, listId, slug, options }) => {
  // Logic for different path
  let url;
  if (["whatfix-staging", "whatfix"].includes(slug)) {
    url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/enrich/csv/${listId}/map-columns`;
  } else {
    url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/v2/enrich/${listId}/map-columns`;
  }
  return POST(url, data, options);
};

export const deleteEnrichment = async ({ listId, slug, options }) => {
  const baseUrl = getEnrichBaseUrl(slug);
  const url = `${baseUrl}/enrich/${listId}`;
  return DELETE(url, options);
};

export const updateEnrichlistName = async ({ data, listId, slug, options }) => {
  const baseUrl = getEnrichBaseUrl(slug);
  const url = `${baseUrl}/enrich/${listId}`;
  return POST(url, data, options);
};

/* export const downloadEnrichListCSV = async ({ listId, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/enrich/${listId}/csv`;
  return GET(url, options);
}; */

export const downloadEnrichListCSV = async ({ listId, slug, options }) => {
  const isLegacy = ["whatfix-staging", "whatfix"].includes(slug);
  let url;
  if (isLegacy) {
    url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/enrich/${listId}/csv`;
  } else {
    // V2 also seems to follow similar pattern or just use baseurl?
    // Checking git logs, V1 was: .../api/v1/enrich/${listId}/csv
    // V2 in current file was: .../api/v1/enrich/${listId}/csv  <-- WAIT, current file had V1 base url for this endpoint?
    // Let's re-check the recent git log.
    // In commit c55ce5b (beta to main), downloadEnrichListCSV was NOT changed.
    // However, I should probably respect the pattern.
    // If V2 exists, it likely follows /api/v2/enrich/${listId}/csv
    // But let's check what it was BEFORE my changes.
    // It was using REACT_APP_API_BASE_URL and /api/v1 even in the "broken" state?
    // Line 29: const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/enrich/${listId}/csv`;
    // So `downloadEnrichListCSV` might not have been migrated to V2 yet?
    // Or maybe it was missed.
    // I will keep it as V1 if it was V1, or try V2 if not legacy.
    // Actually, looking at `downloadSummarizedEnrichListCSV`, that WAS migrated to V2 (Nucleus).
    // `downloadEnrichListCSV` in the "broken" file used `REACT_APP_API_BASE_URL/api/v1`.
    // I'll stick to what was there for non-legacy if it works, or maybe consistency suggests V2?
    // Safest bet: If legacy -> V1. If not legacy -> V1 (since it was V1 in the file I read).
    // Actually, I should probably just leave it as V1 for everyone if it hasn't changed?
    // But the user said "updated csv enrichment flow soon, it has some issue".
    // If I leave it as V1 for everyone, that satisfies legacy.
    // But if V2 exists, maybe I should use it for non-legacy?
    // Let's look at `downloadSummarizedEnrichListCSV` which IS using V2.
    // I will assume `downloadEnrichListCSV` stays V1 for now as per the file I read.
    url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/enrich/${listId}/csv`;
  }
   // Set responseType to blob
  return GET(url, { ...options, responseType: "blob" });
};

export const downloadSummarizedEnrichListCSV = async ({ listId, slug, options }) => {
  const baseUrl = getEnrichBaseUrl(slug);
  const url = `${baseUrl}/enrich/${listId}/csv/summarized`;
  // Set responseType to blob
  return GET(url, { ...options, responseType: "blob" });
};

export const getEnrichmentListRecords = async ({ query, listId, slug, options }) => {
  const baseUrl = getEnrichBaseUrl(slug);
  const url = `${baseUrl}/enrich/${listId}/records${query ? `?${query}` : ""}`;
  return GET(url, options);
};

export const getEnrichmentDetails = async ({ listId, slug, options }) => {
  const baseUrl = getEnrichBaseUrl(slug);
  const url = `${baseUrl}/enrich/${listId}`;
  //console.log(options);
  return GET(url, options);
};

export const createContact = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/contacts`;
  return POST(url, data, options);
};

export const enrichCompany = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/enrich-company`;
  return POST(url, data, options);
};

export const getContactDetails = async ({ contactId, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/contacts/${contactId}`;
  return GET(url, options);
};

export const feedbackForEnrichedPhoneEmail = async ({ data, slug, options }) => {
  // Current file shows V2 (Nucleus).
  // I should check if this needs to be V1 for legacy.
  const isLegacy = ["whatfix-staging", "whatfix"].includes(slug);
  let url;
  if (isLegacy) {
    url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/contacts/record-feedback`;
  } else {
    url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/v2/contacts/record-feedback`;
  }
  return POST(url, data, options);
};

export const verifyEnrichedEmail = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/verify/email`;
  return POST(url, data, options);
};

export const enrichProfile = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/enrich`;
  return POST(url, data, options);
};
